import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatWIB } from "@/lib/format";
import { ScrollText, User, ArrowRight } from "lucide-react";

const ENTITY_TYPES = ["task", "position", "assignment", "user", "late_report", "comment"];
const ACTION_LABEL = {
  create_task: "Membuat tugas", task_terima: "Menerima tugas", task_mulai: "Mulai mengerjakan",
  task_kirim_verifikasi: "Kirim verifikasi", task_verifikasi_setujui: "Menyetujui verifikasi",
  task_verifikasi_revisi: "Meminta revisi", task_batal: "Membatalkan tugas", task_terkendala: "Menandai terkendala",
  delegate_task: "Mendelegasikan tugas", update_progress: "Memperbarui progres", toggle_checklist: "Ubah checklist",
  create_late_report: "Membuat laporan keterlambatan", review_late_report: "Meninjau laporan keterlambatan",
  create_position: "Membuat posisi", update_position: "Memperbarui posisi", move_position: "Memindahkan posisi",
  assign_position: "Menempatkan user", create_user: "Membuat user", import_structure: "Impor struktur",
  add_comment: "Menambah komentar",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [type, setType] = useState("all");

  const load = () => api.get("/audit", { params: type === "all" ? {} : { entity_type: type } }).then((r) => setLogs(r.data)).catch(() => setLogs([]));
  useEffect(() => { load(); }, [type]);

  return (
    <div>
      <div className="flex items-center justify-between gap-3 mb-6 flex-wrap">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 flex items-center gap-2"><ScrollText className="h-7 w-7 text-indigo-500" />Audit Log</h1>
          <p className="text-slate-500 text-sm">Catatan aktivitas immutable — siapa, apa, kapan</p>
        </div>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="w-52" data-testid="audit-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua Entitas</SelectItem>
            {ENTITY_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
        {logs.length === 0 ? <div className="p-10 text-center text-slate-400">Belum ada aktivitas.</div> : (
          <div className="divide-y divide-slate-100">
            {logs.map((l) => (
              <div key={l.id} className="flex items-start gap-3 px-4 py-3 hover:bg-slate-50" data-testid="audit-log-timeline-item">
                <div className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-full bg-indigo-50 text-indigo-600 shrink-0"><User className="h-4 w-4" /></div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-slate-700">
                    <span className="font-semibold">{l.actor_name}</span>{" "}
                    <span className="text-slate-500">{ACTION_LABEL[l.action] || l.action}</span>{" "}
                    <span className="inline-flex items-center gap-1 text-xs text-slate-400"><ArrowRight className="h-3 w-3" />{l.entity_type}</span>
                  </p>
                  <p className="text-xs text-slate-400 mt-0.5">{formatWIB(l.created_at)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
